import React from 'react';
import './ListaAsistencia.css';
import HeaderComponent from '../../components/ListaAsistencia/Header/Header';
import ListaAsistenciaComponent from '../../components/ListaAsistencia/ListaAsistencia/ListaAsistencia';

const ListaAsistencia = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <HeaderComponent />
        </div>
        <div>
            <ListaAsistenciaComponent />
        </div>
      </div>
    );
  };
  
export default ListaAsistencia;

